import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconHeartHome(
  { srText, size = 'md', className = '', ...props }: Props,
) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={24}
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <defs>
          <clipPath id='heart-home_svg__a'>
            <path d='M4 13h18v10.293H4Zm0 0' />
          </clipPath>
          <clipPath id='heart-home_svg__b'>
            <path d='M1.395 1H23.98v13H1.395Zm0 0' />
          </clipPath>
        </defs>
        <g clipPath='url(#heart-home_svg__a)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.41176}
            d='M4.922 13.883v7.058c0 .375.148.735.414 1 .266.262.625.41 1 .41h12.703c.375 0 .734-.148 1-.41.266-.265.414-.625.414-1v-7.058'
          />
        </g>
        <g clipPath='url(#heart-home_svg__b)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.41176}
            d='m2.102 12.594 9.586-9.59a1.41 1.41 0 0 1 1.539-.309c.171.07.328.176.46.309l9.59 9.59'
          />
        </g>
        <path
          fill='none'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.41176}
          d='M16.922 6.238V4h3.531v5.77M16.387 11.855a1.8 1.8 0 0 0-.59-.41 1.7 1.7 0 0 0-.703-.144c-.242 0-.485.047-.707.144a1.8 1.8 0 0 0-.59.41L12.687 13l-1.109-1.145a1.8 1.8 0 0 0-.59-.41 1.7 1.7 0 0 0-.703-.144c-.242 0-.484.047-.707.144a1.8 1.8 0 0 0-.59.41 1.936 1.936 0 0 0 0 2.676l3.305 3.418c.05.055.113.098.18.125q.104.042.215.043a.6.6 0 0 0 .214-.043.5.5 0 0 0 .18-.125l3.305-3.418a1.94 1.94 0 0 0 0-2.676m0 0'
        />
      </svg>
    </>
  )
}
IconHeartHome.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconHeartHome
